function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Website Analytics — page shell (PlunkDocs specs/WEB_ACTIVITY_DASHBOARD_2026-09-28.md).
 * One page, seven views: Overview · Acquisition · Pages · Products · Places ·
 * Funnels · Heat. The first five render here; Funnels and Heat keep their own
 * views and routes (the shared switcher links across). Range + comparison come
 * from the global top bar (period-store); the Site chip reads /hosts.
 * Mockup of record: specs/mockups/web-activity-dashboard-2026-09-28.html
 */
import React from "react";
import { withRouter } from "react-router";
import Overview from "./overview";
import { Acquisition, Pages, Products, Places } from "./drilldowns";
import WebActivitySwitcher from "../../components/site-activity-tabs";
import WebActivityHeader from "./header";
import Auth from "../../functions/authenticate";
import publishSearch from "../../functions/publish-search";
import publishEvent from "../../functions/publish-event";
import { rangeLabelFor, RANGES } from "../sales/territory-common";
import { getGlobalRange, getGlobalComp, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { getHosts, getWindow, safe, previousPreset, isCustomRange } from "./data";
export const VIEWS = ["overview", "acquisition", "pages", "products", "places"];
class WebActivityView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "go", v => {
      if (v === "funnels") return this.props.history.push(`/Activity/Funnels/${this.state.range}`);
      if (v === "heat") return this.props.history.push(`/Activity/Heat/${this.state.range}`);
      this.props.history.push(v === "overview" ? "/Activity" : `/Activity/${v}`);
    });
    this.state = {
      range: getGlobalRange("this_month"),
      comp: getGlobalComp("prev_period"),
      hosts: null,
      win: null,
      ready: false
    };
    this._alive = true;
  }
  async componentDidMount() {
    publishSearch("");
    publishEvent("reset-search", {});
    if (Auth.isAuthenticated() || (await Auth.attachOrSignIn())) this.setState({
      ready: true
    }, () => this.meta());
    this._tok = subscribePeriod(({
      range,
      comp
    }) => {
      if (!this._alive) return;
      this.setState({
        range: range || getGlobalRange("this_month"),
        comp: comp || this.state.comp
      }, () => this.meta());
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._tok);
  }
  async meta() {
    const {
      range
    } = this.state;
    const [hosts, win] = await Promise.all([safe(getHosts(range)), safe(getWindow(range))]);
    if (this._alive) this.setState({
      hosts: hosts && hosts.hosts ? hosts.hosts : null,
      win: win || null
    });
  }
  view() {
    const v = (this.props.params && this.props.params.view || "overview").toLowerCase();
    return VIEWS.indexOf(v) >= 0 ? v : "overview";
  }
  subtitle() {
    const {
      range,
      comp,
      win
    } = this.state;
    const dates = win && win.startDate && win.endDate ? `${fmtD(win.startDate)} – ${fmtD(win.endDate)}` : "";
    const prev = previousPreset(range);
    const cmp = isCustomRange(range) || !prev ? "no comparison for this range" : comp === "prev_year" ? `vs ${prev.replace("_", " ")} (year-over-year arrives in phase 3)` : `vs ${prev.replace("_", " ")}`;
    const asOf = win && win.rollupAt ? `data through ${fmtD(win.rollupAt)}` : "as of the nightly rollup";
    return [rangeLabelFor(range, RANGES), dates, cmp, asOf].filter(Boolean).join(" · ");
  }
  render() {
    const {
      range,
      hosts,
      ready
    } = this.state;
    const view = this.view();
    const props = {
      range,
      go: this.go,
      host: null
    };
    const body = !ready ? null : view === "acquisition" ? /*#__PURE__*/React.createElement(Acquisition, props) : view === "pages" ? /*#__PURE__*/React.createElement(Pages, props) : view === "products" ? /*#__PURE__*/React.createElement(Products, props) : view === "places" ? /*#__PURE__*/React.createElement(Places, props) : /*#__PURE__*/React.createElement(Overview, props);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view"
    }, /*#__PURE__*/React.createElement(WebActivityHeader, {
      range: range,
      comp: this.state.comp
    }), /*#__PURE__*/React.createElement(WebActivitySwitcher, {
      active: view,
      range: range
    }), body);
  }
}
export default withRouter(WebActivityView);